export default function temperaturaParaPressao(number){
    const resultTemp = 3.29416512 + (0.160670831*number) + (0.00234445118*(number**2)) + (0.0000154408872*(number**3)) + ((3.43096037*(10**-8))*(number**4))
    return resultTemp;
}